import React, { PureComponent } from 'react'
import { Link } from 'react-router-dom'
import { Breadcrumb, Container, Card } from 'semantic-ui-react'
import { isAuthenticated } from '../services/self'
import { confirmMarketplaceSubscription } from '../services/api-catalog'
import { getQueryString } from '../services/misc'
import styles from '../components/rex.css'

export default class HomePage extends PureComponent {
    constructor() {
        super()
        this.state = {}

        const { usagePlanId, token } = getQueryString()
        if (usagePlanId && token) {
            this.state = { usagePlanId, token }

            if (isAuthenticated()) {
                confirmMarketplaceSubscription(usagePlanId, token).then(() => {
                    window.location.href = '/apis'
                })
            }
        }
    }

    render() {
        return (
            <div>
                <section className="rex-header">
                    <Breadcrumb className={styles.rexBreadcrumb}>
                        <Breadcrumb.Section active>Home</Breadcrumb.Section>
                    </Breadcrumb>
                </section>
                <section className="rex-content">
                    <Container>
                        <Card.Group itemsPerRow={2} stackable style={{ textAlign: 'center', padding: '10px' }}>
                            <Card className={styles.rexCard}>
                                <Card.Content>
                                    <Card.Header><Link to='/apis'>API Explorer</Link></Card.Header>
                                    <Card.Description>Explore our API and documentation</Card.Description>
                                </Card.Content>
                            </Card>
                            <Card className={styles.rexCard}>
                                <Card.Content>
                                    <Card.Header><Link to='/getting-started'>Getting Started</Link></Card.Header>
                                    <Card.Description>Everything you need to get up and running in no time.</Card.Description>
                                </Card.Content>
                            </Card>
                            <Card className={styles.rexCard}>
                                <Card.Content>
                                    <Card.Header><Link to='/api-limit'>API Limit</Link></Card.Header>
                                    <Card.Description>How to get the best out of our API.</Card.Description>
                                </Card.Content>
                            </Card>
                        </Card.Group>
                    </Container>
                </section>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/pages/Home.js